<template lang="html">
  <div>
    <v-toolbar color="primary" app dark :extended="extended">
      <v-toolbar-side-icon @click.stop="toggleDrawer"></v-toolbar-side-icon>
      <v-toolbar-title>
        <template v-if="!loading">
          {{title}}
        </template>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <slot/>
      </v-toolbar-items>
      <template slot="extension" v-if="extended">
        <slot name="extension">default extended</slot>
      </template>
    </v-toolbar>
  </div>
</template>
<script>
import _ from 'lodash';

import FreeBeta from '@/components/FreeBeta';

export default {
  name: 'Toolbar',
  components: {
    FreeBeta,
  },
  props: {
    title: {
      type: String,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    extended: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  methods: {
    toggleDrawer() {
      this.$store.dispatch('applications/toggleDrawer');
    },
  },
  computed: {
    _() {
      return _;
    },
  },
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Toolbar.vue